import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @font-face {\n    font-weight: 400 700;\n    font-family: 'AudiType';\n    font-style: normal;\n    font-stretch: 100% 130%;\n    src: url(", ")\n      format('woff2-variations');\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \"audi-iconfont-", "\";\n    src: url(", ")\n    format('woff2-variations');\n    font-weight: normal;\n    font-style: normal;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components';
import { IconFontFileName, iconFontVersion } from './iconFontVersion';
var DEFAULT_FONT_URL = 'https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2';
var DEFAULT_ICON_FONT_URL = "https://react.ui.audi/assets/webfonts/icon/".concat(IconFontFileName);
export var GlobalStyles = createGlobalStyle(_templateObject(), function (props) {
  return props.fontUrl || DEFAULT_FONT_URL;
}, iconFontVersion, function (props) {
  return props.iconFontUrl || DEFAULT_ICON_FONT_URL;
});